import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'CurrencyDecimal',
})
export class CurrencyDecimalPipe implements PipeTransform {
  transform(value: any, currency?: any, unFixed?: boolean): any {
    let withDot = value.toString().indexOf('.');
    //
    value = unFixed ? (withDot ? value.toFixed(2) : value) : value.toFixed(8);
    value = value.toString().replace(/(\d)(?=(\d{3})+\.)/g, '$1,');
    //
    let x = this.doSplit(value, '.');
    return `${currency} ${x[0]}${x[1] ? '.' + x[1] : ''}`;
  }

  doSplit(v, d) {
    return v.toString().split(d);
  }
}
